import React, { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
	fetchFournisseurs,
	fetchFournitures,
} from "../../store/actions/autreActions"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync } from "@fortawesome/free-solid-svg-icons"
import { generalStyles } from "../styles/styles"
import { tableStyles as ts } from "../styles/tableStyles"
import { COLORS } from "../../utilities/Constants"

// Onglet « Sous-traitants » du modal d'inventaire — rendu V2 (generalStyles +
// tokens de tableau partagés), cohérent avec les onglets Stock / Stock virtuel.
// Liste fournitures volontairement non paginée (petit volume par fournisseur).

const FournitureRow = ({ fourniture, index, onAdd }) => {
	const [hover, setHover] = useState(false)
	return (
		<tr
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			onDoubleClick={() => onAdd(fourniture)}
			title="Double-cliquez pour ajouter"
			style={{
				backgroundColor: hover ? ts.rowHover : ts.rowBg(index),
				cursor: "pointer",
				transition: "background-color 0.12s",
			}}
		>
			<td style={{ ...ts.td, fontWeight: 600 }}>{fourniture.label}</td>
		</tr>
	)
}

const AtelierInventaireFournitureModal = ({
	addAtelierLigneFourniture,
	addAtelierLigneSousTraitantAutre,
	closeModal,
	typeAl,
}) => {
	const [selectedFournisseur, setSelectedFournisseur] = useState(0)
	const dispatch = useDispatch()
	const { autreInfo } = useSelector((state) => state)
	const { fournisseurs, fournitures } = useSelector(
		(state) => state.autreInfo,
	)
	const changeFournisseur = (id) => {
		setSelectedFournisseur(id)
		dispatch(fetchFournitures(id))
	}
	const filteredFournisseurs = useMemo(() => {
		if (typeAl === 0) return fournisseurs.filter((f) => f.has_fournitures)
		return fournisseurs
	}, [fournisseurs, typeAl])
	useEffect(() => {
		dispatch(fetchFournisseurs())
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const addFourniture = (four) => {
		addAtelierLigneFourniture(four, selectedFournisseur)
		closeModal()
	}

	return (
		<div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
			<div style={generalStyles.fieldRow}>
				<label style={{ ...generalStyles.label, minWidth: "auto" }}>
					Sous-traitant
				</label>
				{autreInfo.fetchFournisseurs.loading ? (
					<FontAwesomeIcon icon={faSync} spin />
				) : (
					<select
						style={{ ...generalStyles.select, minWidth: 200 }}
						value={selectedFournisseur}
						onChange={(e) =>
							changeFournisseur(parseInt(e.target.value))
						}
					>
						<option value={0}>-</option>
						{filteredFournisseurs.map((four) => (
							<option key={`four_${four.id}`} value={four.id}>
								{four.label}
							</option>
						))}
					</select>
				)}
			</div>

			{/* Le tableau (et son en-tête) n'apparaît qu'une fois un sous-traitant
			    choisi : pas de header « Fournitures » à vide. */}
			{typeAl === 0 &&
				selectedFournisseur > 0 &&
				(autreInfo.fetchFournitures.loading ? (
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							padding: 24,
						}}
					>
						<FontAwesomeIcon icon={faSync} spin />
					</div>
				) : (
					<>
						<div
							style={{
								maxHeight: "48vh",
								overflowY: "auto",
							}}
						>
							<div style={ts.container}>
								<table style={ts.table}>
									<thead>
										<tr>
											<th style={ts.th}>Fournitures</th>
										</tr>
									</thead>
									<tbody>
										{fournitures.map((four, i) => (
											<FournitureRow
												key={`fourniture_${four.id}`}
												fourniture={four}
												index={i}
												onAdd={addFourniture}
											/>
										))}
									</tbody>
								</table>
								{fournitures.length === 0 && (
									<div style={ts.empty}>
										Aucune fourniture trouvée.
									</div>
								)}
							</div>
						</div>
						{fournitures.length > 0 && (
							<div
								style={{
									color: COLORS.textMuted,
									fontSize: 12,
								}}
							>
								Double-cliquez sur une fourniture pour l'ajouter.
							</div>
						)}
					</>
				))}

			{typeAl === 2 && (
				<button
					type="button"
					style={{
						...generalStyles.btnPrimary,
						alignSelf: "flex-start",
						opacity: selectedFournisseur === 0 ? 0.5 : 1,
					}}
					onClick={() => {
						addAtelierLigneSousTraitantAutre(selectedFournisseur)
						closeModal()
					}}
					disabled={selectedFournisseur === 0}
				>
					Ajouter
				</button>
			)}
		</div>
	)
}

export default AtelierInventaireFournitureModal
